import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=70afa036&scoped=true&"
import script from "./UploadExcel.vue?vue&type=script&lang=js&"
export * from "./UploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=70afa036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afa036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70afa036')) {
      api.createRecord('70afa036', component.options)
    } else {
      api.reload('70afa036', component.options)
    }
    module.hot.accept("./UploadExcel.vue?vue&type=template&id=70afa036&scoped=true&", function () {
      api.rerender('70afa036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadExcel.vue"
export default component.exports